import { Button } from 'antd';
import { OutlineButton } from 'components/UI/Buttons';
import { bucketS3, caminhoAnexosComponentsInteraction } from 'constants/EnvironmentData';
import Colors from 'enums/Colors';
import ComponentGameMemory from 'models/componentInteraction/ComponentGameMemory';
import ComponentGameMemoryCard from 'models/componentInteraction/ComponentGameMemoryCard';
import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaQuestion } from 'react-icons/fa';
import { IoReload } from 'react-icons/io5';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `,

    Content: {
        Container: styled.div`
            display: grid;
            grid-template-columns: 150px 150px 150px 150px;
            align-items: center;
            justify-content: center;
            padding: 22px;
        `,
    },

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 600;
        font-size: 22px;
        line-height: 26.4px;
        letter-spacing: 0%;
        vertical-align: middle;
        text-align: center;
        color: ${Colors.Blue};
    `,

    SubTitle: styled.h2`
        font-family: 'Barlow';
        font-weight: 600;
        font-size: 18px;
        line-height: 22.4px;
        letter-spacing: 0%;
        vertical-align: middle;
        text-align: center;
        color: ${Colors.Blue};
    `,

    Card: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 140px;
        height: 140px;
        border-radius: 8px;
        margin-bottom: 10px;
        border: 1px solid ${Colors.Grey13};
        cursor: pointer;
        transition: all 0.5s;
    `,

    TitleFeed: styled.h1`
        color: ${Colors.Blue};
        font-size: 28px;
        font-weight: 700;
    `,
};

interface IComponentGameMemoryPublic {
    dados: ComponentGameMemory[];
}

const ComponentGameMemoryPublic: React.FC<IComponentGameMemoryPublic> = ({ dados }) => {
    const [indexGame, setIndexGame] = useState<number>(0);
    const [gameMemorys, setGameMemorys] = useState<ComponentGameMemory[]>([]);
    const [contador, setContador] = useState(0);

    const [indexCardMatch, setIndexCardMatch] = useState<number[]>([]);
    const [cardMatch, setCardMatch] = useState<number[]>([]);

    const [finishGame, setFinishGame] = useState<boolean>(false);
    const [initialGame, setInitialGame] = useState<boolean>(false);

    const [viewFeedback, setViewFeedback] = useState<boolean>(false);

    const getS3BaseUrl = (): string => {
        return bucketS3() + caminhoAnexosComponentsInteraction();
    };

    //Randomiazar os cards.
    const shuffleArray = (arrays: ComponentGameMemoryCard[]) => {
        for (let i = arrays.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));

            [arrays[i], arrays[j]] = [arrays[j], arrays[i]];
        }

        return arrays;
    };

    const gameReload = () => {
        if (dados) {
            setCardMatch([]);

            const updated = dados.map((game: ComponentGameMemory) => {
                const originalCards = [...game.cards]; // cópia dos originais
                const duplicated = [...originalCards, ...originalCards];
                const shuffled = shuffleArray(duplicated);

                return {
                    ...game,
                    cards: shuffled,
                };
            });

            setGameMemorys(updated as ComponentGameMemory[]);
        } else {
            setGameMemorys([]);
        }
    };

    useEffect(() => {
        gameReload();
    }, [dados]);

    useEffect(() => {
        if (indexCardMatch.length === 1) setInitialGame(true);

        if (indexCardMatch.length === 2) {
            const verify = () => {
                const card1 = gameMemorys[indexGame].cards[indexCardMatch[0]].codigo;
                const card2 = gameMemorys[indexGame].cards[indexCardMatch[1]].codigo;

                if (card1 === card2) {
                    setCardMatch([...cardMatch, card1]);
                    setIndexCardMatch([]);
                } else {
                    setIndexCardMatch([]);
                }
            };

            const timeout = setTimeout(() => {
                verify();
            }, 1000);

            return () => clearTimeout(timeout);
        }
    }, [indexCardMatch]);

    useEffect(() => {
        const quantityCardOriginal = dados[indexGame].cards.length;

        if (quantityCardOriginal && quantityCardOriginal > 0) {
            if (quantityCardOriginal === cardMatch.length) {
                setFinishGame(true);
                setInitialGame(false);
            }
        }
    }, [cardMatch]);

    useEffect(() => {
        let interval: NodeJS.Timeout;

        if (initialGame && !finishGame && gameMemorys[indexGame].haveTime) {
            interval = setInterval(() => {
                setContador(prev => prev + 1);
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [indexCardMatch, indexGame]);

    const minutos = Math.floor(contador / 60);
    const segundos = contador % 60;

    // Formatando com zero à esquerda
    const formatado = `${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;

    return (
        <Styled.Container>
            {!viewFeedback ? (
                gameMemorys.map((game, indexG) => (
                    <>
                        {indexGame === indexG && (
                            <div>
                                <div key={indexG}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Styled.Title>{game.title}</Styled.Title>
                                        <Styled.SubTitle>
                                            Jogo da memória: {indexG + 1}/{gameMemorys.length}
                                        </Styled.SubTitle>
                                    </div>
                                    <Styled.Content.Container>
                                        {game.cards.map((card, indexCard) => (
                                            <Styled.Card
                                                key={indexCard}
                                                onClick={() => {
                                                    indexCardMatch.length < 2 &&
                                                        !cardMatch.includes(card.codigo) &&
                                                        !indexCardMatch.includes(indexCard) &&
                                                        setIndexCardMatch([...indexCardMatch, indexCard]);
                                                }}
                                            >
                                                <FaQuestion
                                                    size={32}
                                                    color={Colors.Blue}
                                                    style={{
                                                        position: 'absolute',
                                                        opacity: cardMatch.includes(card.codigo)
                                                            ? 0
                                                            : 1 || indexCardMatch.includes(indexCard)
                                                            ? 1
                                                            : 0,
                                                        zIndex: 0,
                                                    }}
                                                />
                                                <img
                                                    draggable={false}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        transition: 'all 0.5s ease-in-out',
                                                        opacity: cardMatch.includes(card.codigo)
                                                            ? 1
                                                            : 0 || indexCardMatch.includes(indexCard)
                                                            ? 1
                                                            : 0,
                                                        zIndex: 1,
                                                    }}
                                                    src={getS3BaseUrl() + card.filepath}
                                                    alt=""
                                                />
                                            </Styled.Card>
                                        ))}
                                    </Styled.Content.Container>
                                    <div
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            gap: '1rem',
                                        }}
                                    >
                                        {gameMemorys && gameMemorys[indexGame].haveTime && (
                                            <h1 style={{ fontWeight: 700, color: Colors.Blue, fontSize: 18 }}>Tempo gasto: {formatado}</h1>
                                        )}
                                        <div style={{ display: 'flex', gap: '1rem' }}>
                                            {finishGame && gameMemorys.length > indexGame + 1 && (
                                                <OutlineButton
                                                    style={{ width: '220px' }}
                                                    onClick={() => {
                                                        setFinishGame(false);
                                                        setIndexGame(indexGame + 1);
                                                        setCardMatch([]);
                                                        setContador(0);
                                                    }}
                                                >
                                                    Próximo jogo da memória
                                                </OutlineButton>
                                            )}

                                            {finishGame && gameMemorys.length === indexGame + 1 && (
                                                <OutlineButton
                                                    style={{ width: '220px' }}
                                                    onClick={() => {
                                                        setCardMatch([]);
                                                        setViewFeedback(true);
                                                    }}
                                                >
                                                    Concluir exercícios
                                                </OutlineButton>
                                            )}

                                            {finishGame && (
                                                <OutlineButton
                                                    style={{ width: '40px' }}
                                                    onClick={() => {
                                                        setFinishGame(false);
                                                        setContador(0);
                                                        gameReload();
                                                    }}
                                                >
                                                    <IoReload size={22} />
                                                </OutlineButton>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                ))
            ) : (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '1rem' }}>
                        <FaCheckCircle size={48} color={Colors.BrightGreen} />
                        <Styled.TitleFeed>Parabéns, você concluiu a tarefa!</Styled.TitleFeed>
                        <OutlineButton
                            style={{ width: '220px' }}
                            onClick={() => {
                                setViewFeedback(false);
                                setFinishGame(false);
                                setIndexGame(0);
                                gameReload();
                            }}
                        >
                            Tentar novamente
                        </OutlineButton>
                    </div>
                </>
            )}
        </Styled.Container>
    );
};

export default ComponentGameMemoryPublic;
